import React, { useState, useEffect, type FunctionComponent } from 'react'
import { useParams } from 'react-router-dom'
import { authenticatedFetchData, API_HOST } from '../../../lib'
import { logError } from '@tomra/datadog-browser-logging'
import { PendingBagsTable } from '../../common/PendingBagsTable'

export const UserPendingBags: FunctionComponent = () => {
  const { userId } = useParams()
  const [pendingBagsList, setPendingBagsList] = useState<PendingBagType[]>()
  const [requestStatus, setRequestStatus] = useState<string>('loading')

  useEffect(() => {
    const f = authenticatedFetchData(
      `${API_HOST}/mytomra/v1.0/hotlinetool/pendingbags?userid=${encodeURIComponent(userId || '')}`
    )

    f.run().then(
      (pendingBagsList: PendingBagType[]) => {
        setRequestStatus('')
        setPendingBagsList(pendingBagsList)
      },
      (error: Error) => {
        if (error.name !== 'AbortError') {
          setRequestStatus('failed')
          logError(new Error('Failed to fetch pending bags for user'), error)
        }
      }
    )

    return () => f.abort()
  }, [userId])

  if (pendingBagsList) {
    return pendingBagsList.length > 0 ? (
      <PendingBagsTable pendingBags={pendingBagsList} />
    ) : (
      <div className="p-4">This user has no pending bags.</div>
    )
  }

  if (requestStatus === 'failed') {
    return (
      <div className="rounded-lg border-l-[3px] border-rose-500 bg-white p-4 text-left shadow-md dark:bg-gray-900 centerAbsolute">
        Whoopsie! Failed to fetch pending bags for user.
      </div>
    )
  }

  return (
    <div className="p-4">
      <div className="loadingSpinner" />
    </div>
  )
}
